import styles from './Search.module.scss';

export default function Placeholder() {
  return <div className={styles.Placeholder} />;
}
